/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
import { call, put, takeLatest, select, all, fork, join } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import { getAlternateBrandName } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import {
  updateColorFitsSizesMapWithSFCCInventoryData,
  updateRawDataWithSFCCInventoryData,
  isPureVMPProduct,
} from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import MAX_PRODUCT_PART_NUMBER_ALLOWED from '@tcp/core/src/constants/numeric.constants';
import logger from '@tcp/core/src/utils/loggerInstance';
import { resetAlternateBrandInPickUp } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  getStringAfterSplit,
  getMultipackCount,
  filterMultiPack,
} from '../../../../../utils/utils';
import QUICK_VIEW_CONSTANT from './QuickViewModal.constants';
import {
  setQuickView,
  setModalState,
  setItemFromBagInfoForQuickView,
  setLoadingState,
  setLoadingError,
  setModuleX,
  setMultiPackDetails,
  singlePageLoadAction,
  quickViewSingleLoad,
  setDisableSelectedTab,
  setBrandName,
  setTotalPrices,
  setQVProductID,
  updateDataOnNewFitsClick,
  setEvar152,
} from './QuickViewModal.actions';
import getProductInfoById, {
  sfccInventoryApi,
} from '../../../../../services/abstractors/productListing/productDetail';
import { getUserSelectionApi } from '../../../../../services/abstractors/productListing/userbrowsehistory';
import { getModuleX } from '../../../../../services/abstractors/common/moduleX';
import {
  getIsPdpServiceEnabled,
  getABTestPdpService,
  getIsPDPInventoryCheckEnabled,
  getIsOOSColorSwatchRemoved,
  getIsExtendedInventoryPromoMessagingEnabled,
  getShowStoreSpecialsV2,
  getStoreSpecialsPREnabled,
  getSfccSocialProofingEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getIsQVOpen } from './QuickViewModal.selectors';
import { isVmpOrPvmpProduct } from '../../../../features/browse/ProductDetail/container/ProductDetail.saga';
import { getDefaultFavStore } from '../../../../features/account/User/container/User.selectors';

function* setQuickViewLoadingState(isLoading, isModalOpen) {
  yield put(setModalState({ isModalOpen }));
  yield put(setLoadingState({ isLoading }));
}

function fetchProductId(findUpdatedPartId) {
  let newPartId;
  let multiplePartId = '';
  if (findUpdatedPartId.includes(',')) {
    const arrayOfPartNum = getStringAfterSplit(findUpdatedPartId, ',');
    for (let i = 0; i < arrayOfPartNum.length; i += 1) {
      multiplePartId = multiplePartId.concat(getStringAfterSplit(arrayOfPartNum[i], '#')[0]);
      if (i !== arrayOfPartNum.length - 1) {
        multiplePartId = multiplePartId.concat(',');
      }
    }
  } else {
    newPartId = !!findUpdatedPartId && [getStringAfterSplit(findUpdatedPartId, '#')];
    multiplePartId += newPartId ? `${newPartId[0][0]},` : '';
  }
  return multiplePartId;
}

const getMultipackProduct = (newfetchDetailArray) => {
  const filterData =
    newfetchDetailArray &&
    newfetchDetailArray.product &&
    newfetchDetailArray.product.categoryIdList;
  return filterData && filterMultiPack(filterData);
};

const checkIfMultiPack = (payload) => {
  return payload && payload.isMultiPack ? payload.isMultiPack : null;
};

function* getQuickViewData(productDetailArray, payload) {
  if (!payload.getDetailonClick) {
    if (productDetailArray[0]?.product?.colorConsolidationTCPmapNewStyleId?.length > 0) {
      yield put(
        singlePageLoadAction({
          singlepageload: true,
          availableTCPMultipackProductMapping:
            productDetailArray[0].product &&
            productDetailArray[0].product.TCPMultipackProductMapping,
          availableTCPMultipackProductMappingQuickView:
            productDetailArray[0].product &&
            productDetailArray[0].product.TCPMultipackProductMapping,
          availableTCPmapNewStyleId:
            productDetailArray[0].product && productDetailArray[0].product.TCPmapNewStyleId,
          availableColorConsolidationTCPmapNewStyleId:
            productDetailArray[0].product &&
            productDetailArray[0].product.colorConsolidationTCPmapNewStyleId,
          initialSelectedQty:
            productDetailArray[0].product && productDetailArray[0].product.TCPStyleQTY,
        })
      );
    } else {
      yield put(
        singlePageLoadAction({
          singlepageload: true,
          availableTCPMultipackProductMapping:
            productDetailArray[0].product &&
            productDetailArray[0].product.TCPMultipackProductMapping,
          availableTCPMultipackProductMappingQuickView:
            productDetailArray[0].product &&
            productDetailArray[0].product.TCPMultipackProductMapping,
          availableTCPmapNewStyleId:
            productDetailArray[0].product && productDetailArray[0].product.TCPmapNewStyleId,
          initialSelectedQty:
            productDetailArray[0].product && productDetailArray[0].product.TCPStyleQTY,
        })
      );
    }
    yield put(quickViewSingleLoad({ initalQuickViewLoad: true }));
  } else yield put(quickViewSingleLoad({ initalQuickViewLoad: false }));
}

const checkIfProductAvailable = (productDetailArray) => {
  return (
    productDetailArray &&
    productDetailArray[0] &&
    productDetailArray[0].product &&
    productDetailArray[0].product.colorFitsSizesMap.length &&
    productDetailArray[0].product.unbxdProdId
  );
};

function* callSFCCInventoryAPI(productDetailArray, multiPackData, defaultStoreId) {
  const taskData = [];
  try {
    for (let i = 0; i < productDetailArray.length; i += 1) {
      let currentTaskData = [];
      let INITIAL_VALUE = 0;
      let MAX_VALUE = MAX_PRODUCT_PART_NUMBER_ALLOWED;
      const allProducts = isPureVMPProduct(productDetailArray[i]?.product?.TCPStyleType)
        ? []
        : productDetailArray[i]?.product?.allProductPartNos;
      if (multiPackData?.getNewMultiPackAllColor && i === 0) {
        multiPackData.getNewMultiPackAllColor.forEach((item) => {
          allProducts.push(item?.prodpartno || []);
        });
      }
      let allProductPartNosLength = allProducts?.length;
      // To make multiple calls when allProductPartNosLength is greater that maximum allowed productPartNo value
      while (allProductPartNosLength > 0) {
        const sfccTaskData = yield fork(
          sfccInventoryApi,
          allProducts?.slice(INITIAL_VALUE, MAX_VALUE),
          defaultStoreId
        );
        if (sfccTaskData) {
          currentTaskData = [...currentTaskData, sfccTaskData];
        }
        // Set the INITIAL_VALUE to max value, add maximum allowed prodPartNo to MAX_VALUE, and reduce the allProductParNos length by maximum allowed prodPartNo value for next iteration
        INITIAL_VALUE = MAX_VALUE;
        MAX_VALUE += MAX_PRODUCT_PART_NUMBER_ALLOWED;
        allProductPartNosLength -= MAX_PRODUCT_PART_NUMBER_ALLOWED;
      }
      taskData.push(currentTaskData);
    }
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        title: 'An error occurred while calling SFCC API in QuickView Modal',
        componentName: 'QuickViewModal.saga',
        methodName: 'callSFCCInventoryAPI',
        productDetailArray,
        multiPackData,
      },
    });
  }
  return taskData;
}

function* updateUnbxdDataWithSFCCInventoryData({
  productDetailArray,
  multiPackData,
  taskDataObject,
  currentColorProductId = '',
  defaultStoreId,
}) {
  try {
    const taskData = yield join(taskDataObject);
    const isExtendedInventoryPromoMessagingEnabled = yield select(
      getIsExtendedInventoryPromoMessagingEnabled
    );
    const storeSpecialV2Enabled = yield select(getShowStoreSpecialsV2);
    const storeSpecialPREnabled = yield select(getStoreSpecialsPREnabled);

    const clonedProductDetailArray = JSON.parse(JSON.stringify(productDetailArray));
    let clonedMultiPackData;
    if (multiPackData) {
      clonedMultiPackData = JSON.parse(JSON.stringify(multiPackData));
    }

    for (let i = 0; i < productDetailArray.length; i += 1) {
      let data = [];
      const currentTaskData = taskData?.[i];
      // Loop through the forked requests for i iteration and join to get the final api response
      for (let j = 0; j < currentTaskData?.length; j += 1) {
        const apiResponse = yield join(currentTaskData[j]);
        if (apiResponse) {
          data = [...data, ...apiResponse];
        }
      }

      const isGiftCardProduct = productDetailArray[i]?.product?.isGiftCard;
      const isAccessoryProduct = !isEmpty(
        productDetailArray[i]?.product?.accessoriesData?.accessoriesProductID
      );
      const sfccSocialProofingOn = yield select(getSfccSocialProofingEnabled);
      const shouldUpdateInventoryAttributesCheck =
        isExtendedInventoryPromoMessagingEnabled && !isGiftCardProduct && !isAccessoryProduct;

      let updatedColorFitsSizesMap = updateColorFitsSizesMapWithSFCCInventoryData({
        colorFitsSizesMap: productDetailArray[i]?.product?.colorFitsSizesMap,
        data,
        shouldUpdateInventoryAttributesCheck,
        defaultStoreId,
        storeSpecialV2Enabled,
        storeSpecialPREnabled,
        sfccSocialProofingOn,
      });

      const isOOSColorSwatchRemoved = yield select(getIsOOSColorSwatchRemoved);
      if (isOOSColorSwatchRemoved) {
        const filteredColorFitsSizesMap = updatedColorFitsSizesMap.filter((item) =>
          isVmpOrPvmpProduct(item) ||
          item.colorProductId === currentColorProductId ||
          item.colorProductId === currentColorProductId.replace('-', '_')
            ? true
            : item.maxAvailable !== 0
        );

        if (filteredColorFitsSizesMap?.length > 0) {
          updatedColorFitsSizesMap = filteredColorFitsSizesMap;
        } else {
          updatedColorFitsSizesMap = [updatedColorFitsSizesMap[0]];
        }
      }

      const updatedAllProductId = updateRawDataWithSFCCInventoryData(
        productDetailArray[i]?.product.allProductId,
        data
      );
      const updatedMultiPackAllColor = updateRawDataWithSFCCInventoryData(
        productDetailArray[i]?.product.getMultiPackAllColor,
        data
      );
      if (i === 0 && clonedMultiPackData) {
        const updatedNewMultiPackAllColor = updateRawDataWithSFCCInventoryData(
          clonedMultiPackData?.getNewMultiPackAllColor,
          data,
          false,
          false
        );
        const updatedNewPartNumber = updateRawDataWithSFCCInventoryData(
          clonedMultiPackData?.newPartNumber,
          data,
          false,
          true
        );

        clonedMultiPackData.getMultiPackAllColor = updatedMultiPackAllColor;
        clonedMultiPackData.getNewMultiPackAllColor = updatedNewMultiPackAllColor;
        clonedMultiPackData.newPartNumber = updatedNewPartNumber;
        yield put(setMultiPackDetails({ multiPackData: clonedMultiPackData }));
      }

      const updatedCategoryIdList = updateRawDataWithSFCCInventoryData(
        productDetailArray[i]?.product.categoryIdList,
        data,
        false,
        true
      );

      const updatedNewCategoryIdList = updateRawDataWithSFCCInventoryData(
        productDetailArray[i]?.product.newCategoryIdList,
        data,
        true,
        false
      );

      if (shouldUpdateInventoryAttributesCheck) {
        const currentProductInventoryData = data.find(
          (item) => item.id === productDetailArray[i]?.product?.productId
        );

        if (currentProductInventoryData?.price_max) {
          clonedProductDetailArray[i].product.highOfferPrice =
            currentProductInventoryData?.price_max;
        }
        if (currentProductInventoryData?.price) {
          clonedProductDetailArray[i].product.offerPrice = currentProductInventoryData?.price;
        }
      }

      clonedProductDetailArray[i].product.colorFitsSizesMap = updatedColorFitsSizesMap;
      clonedProductDetailArray[i].product.allProductId = updatedAllProductId;
      clonedProductDetailArray[i].product.getMultiPackAllColor = updatedMultiPackAllColor;
      clonedProductDetailArray[i].product.categoryIdList = updatedCategoryIdList;
      clonedProductDetailArray[i].product.newCategoryIdList = updatedNewCategoryIdList;
      const isQVModalOpen = yield select(getIsQVOpen);
      if (isQVModalOpen) yield put(setQuickView(clonedProductDetailArray));
    }
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        title: 'An error occurred while updating unbxd data with SFCC data in QuickView Modal',
        componentName: 'QuickViewModal.saga',
        methodName: 'updateUnbxdDataWithSFCCInventoryData',
        productDetailArray,
      },
    });
  }
}

function* getProductDetails(productDetailArray) {
  const CheckifProductAvailable =
    productDetailArray &&
    productDetailArray[0] &&
    productDetailArray[0].product &&
    productDetailArray[0].product.colorFitsSizesMap.length &&
    productDetailArray[0].product.unbxdProdId;

  if (!CheckifProductAvailable) {
    yield put(setDisableSelectedTab({ disabledTab: true }));
  } else {
    yield put(setQuickView(productDetailArray));
  }
}

const getFilteredProductArray = (products) => {
  return products?.filter((productObj) => {
    return productObj?.product?.colorFitsSizesMap?.length && productObj?.product.unbxdProdId;
  });
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* fetchProductDetail({ payload }) {
  try {
    yield put(setLoaderState(payload?.isShowLoader));

    yield put(setQVProductID(payload?.colorProductId));
    const state = yield select();
    yield put(resetAlternateBrandInPickUp());
    yield put(setLoadingError({ loadingError: false }));
    yield put(setEvar152({ eVar152: payload.eVar152 || '' }));
    if (!payload?.isShowLoader) yield setQuickViewLoadingState(true, true);

    const payloadArray = Array.isArray(payload) ? payload : [payload];
    const { orderInfo } = payloadArray[0];
    let itemBrand;
    let newfetchDetailArray = null;
    let multiPackCount;
    let finalPartId = '';
    let partId;
    const { brandName, totalPrices, brand } = payload;
    if (orderInfo && !isEmpty(orderInfo)) {
      ({ itemBrand } = orderInfo);
    } else if (brandName) {
      itemBrand = brandName;
    } else {
      itemBrand = brand;
    }
    const dimension66 = payload?.dimension66 || null;
    const dimension81 = payload?.dimension81 || null;
    const isPayloadArray = Array.isArray(payload);
    const pageName = (isPayloadArray && payload[0].fromPage) || '';
    const isOutfitsOnBag = (isPayloadArray && payload[0].isOutfitsOnBag) || false;
    yield put(
      setItemFromBagInfoForQuickView({
        orderInfo,
        fromBagPage: !!payload.fromBagPage,
        isSflProduct: payload.isSflProduct,
        isFavoriteEdit: payload.isFavoriteEdit,
        uniqueId: payload.colorProductId,
        pdpUrl: payload.pdpUrl,
        fromPage: payload.fromPage || pageName,
        sbpNavigation: payload.sbpNavigation || {},
        isSBP: payload.isSBP || false,
        fromAccessory: payload.fromAccessory || false,
        dimension66,
        isFromStoreModal: payload.isFromStoreModal || false,
        dimension81,
        isTopRatedProduct: payload.isTopRatedProduct || false,
        isBestSellerProduct: payload.isBestSellerProduct || false,
        isCrossBrandProduct: payload.isCrossBrandProduct || '',
        isOutfitsOnBag,
        productCrossSellDriver: payload?.productCrossSellDriver || '',
      })
    );

    const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
    const enablePDPServiceABTest = yield select(getABTestPdpService);
    const { fromPage } = payload;
    let alternateBrand;
    if (fromPage !== 'pdp') {
      alternateBrand = getAlternateBrandName(state);
    }
    const viewType = 'QV';
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const currentColorProductId = payloadArray[0]?.colorProductId;
    const { newFitsEnabled } = payload;
    const fetchDetailArray = payloadArray.map((product) => {
      const { colorProductId, generalProductId } = product;
      return call(
        getProductInfoById,
        xappURLConfig,
        colorProductId,
        state,
        itemBrand,
        undefined,
        undefined,
        undefined,
        false,
        undefined,
        generalProductId,
        checkIfMultiPack(payload),
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        null,
        alternateBrand,
        null,
        fromPage,
        viewType,
        undefined,
        undefined,
        isOutfitsOnBag,
        isOutfitsOnBag,
        undefined,
        newFitsEnabled
      );
    });
    const resolveFetchDetail = yield all(fetchDetailArray);
    const productDetailArray =
      isOutfitsOnBag && Array.isArray(resolveFetchDetail)
        ? getFilteredProductArray(resolveFetchDetail)
        : resolveFetchDetail;
    if (
      payload?.productCrossSellDriver &&
      productDetailArray?.length &&
      productDetailArray[0]?.product
    ) {
      productDetailArray[0].product.productCrossSellDriver = payload?.productCrossSellDriver;
    }
    yield getProductDetails(productDetailArray);
    if (!!productDetailArray[0] && !!productDetailArray[0].product && !!alternateBrand) {
      productDetailArray[0].product.alternateBrand = alternateBrand;
    }
    yield getQuickViewData(productDetailArray, payload);
    const totalPartIds = [];
    const oldMultiPackColors = [];
    let isMultipack = false;
    for (let i = 0; i < productDetailArray.length; i += 1) {
      if (
        !!productDetailArray[i] &&
        !!productDetailArray[i]?.product &&
        productDetailArray[i]?.product.multiPackUSStore
      ) {
        partId = productDetailArray[i]?.product.tcpMultiPackReferenceUSStore.join(',').split(',');
        totalPartIds.push(...partId);
        const updatedPartId = new Set(partId);
        const findUpdatedPartId = [...updatedPartId];
        for (let k = 0; k < findUpdatedPartId.length; k += 1) {
          finalPartId += fetchProductId(findUpdatedPartId[k]);
        }
        const newMultiPackCount = findUpdatedPartId[0].split(',');

        multiPackCount = newMultiPackCount && getMultipackCount(newMultiPackCount);
        isMultipack = true;
      }
    }
    if (isMultipack) {
      const multipackReferencesAPICall = true;
      newfetchDetailArray = yield call(
        getProductInfoById,
        xappURLConfig,
        finalPartId,
        state,
        itemBrand,
        undefined,
        undefined,
        undefined,
        multipackReferencesAPICall,
        totalPartIds,
        undefined,
        undefined,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        null,
        alternateBrand
      );
      productDetailArray?.forEach((newFetchProduct) =>
        oldMultiPackColors.push(...newFetchProduct?.product?.getMultiPackAllColor)
      );
    }
    const multiPackData = newfetchDetailArray
      ? {
          newPartNumber: getMultipackProduct(newfetchDetailArray),
          multiPackCount,
          getMultiPackAllColor: oldMultiPackColors,
          getNewMultiPackAllColor:
            newfetchDetailArray && newfetchDetailArray.product.getMultiPackAllColor,
          partIdDetail: newfetchDetailArray && newfetchDetailArray.product.partIdDetails,
        }
      : null;

    const isPDPInventoryCheckEnabled = yield select(getIsPDPInventoryCheckEnabled);
    const isProductAvailable = checkIfProductAvailable(productDetailArray);
    const defaultStore = yield select(getDefaultFavStore);
    const defaultStoreId = defaultStore?.basicInfo?.id;
    let taskDataObject;
    if (isPDPInventoryCheckEnabled && isProductAvailable) {
      taskDataObject = yield fork(
        callSFCCInventoryAPI,
        productDetailArray,
        multiPackData,
        defaultStoreId
      );
    }

    yield getProductDetails(productDetailArray);

    if (productDetailArray?.[0]) {
      getUserSelectionApi();
    }

    yield put(setMultiPackDetails({ multiPackData }));
    yield put(setBrandName({ brandName }));
    if (totalPrices) {
      yield put(setTotalPrices({ totalPrices }));
    }
    yield put(setLoadingState({ isLoading: false }));

    if (isPDPInventoryCheckEnabled && isProductAvailable) {
      yield updateUnbxdDataWithSFCCInventoryData({
        productDetailArray,
        multiPackData,
        taskDataObject,
        currentColorProductId,
        defaultStoreId,
      });
    }
  } catch (err) {
    yield put(setLoaderState(false));
    yield put(setLoadingError({ loadingError: true }));
    yield setQuickViewLoadingState(false, true);
    logger.error('fetchProductDetail: -', {
      error: err,
      extraData: {
        component: 'fetchProductDetail - Saga',
        payloadRecieved: payload,
      },
    });
  }
}

export function* fetchModuleX({ payload = '' }) {
  try {
    const result = yield call(getModuleX, payload);
    yield put(setModuleX(result));
  } catch (err) {
    yield null;
  }
}

export function* fetchDataonNewFitsClick({ payload }) {
  try {
    const { colorProductId, generalProductId, fromPage, multiQVItemIndex } = payload;
    const state = yield select();
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
    const enablePDPServiceABTest = yield select(getABTestPdpService);
    const viewType = 'QV';
    let alternateBrand;
    if (fromPage !== 'pdp') {
      alternateBrand = getAlternateBrandName(state);
    }
    const newFitProductDetail = yield call(
      getProductInfoById,
      xappURLConfig,
      colorProductId,
      state,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
      undefined,
      generalProductId,
      checkIfMultiPack(payload),
      isPdpServiceEnabled,
      enablePDPServiceABTest,
      null,
      alternateBrand,
      null,
      fromPage,
      viewType,
      undefined,
      undefined
    );
    yield put(
      updateDataOnNewFitsClick({
        index: multiQVItemIndex,
        data: newFitProductDetail,
      })
    );
  } catch (error) {
    logger.error({
      error: `Error in MultiItemQVSaga - fetchDataonNewFitsClick catch - ${error}`,
      extraData: {
        component: 'MultiItemQVSaga - fetchDataonNewFitsClick',
      },
    });
  }
}

function* QuickViewSaga() {
  yield takeLatest(QUICK_VIEW_CONSTANT.FETCH_QUICK_VIEW, fetchProductDetail);
  yield takeLatest(QUICK_VIEW_CONSTANT.FETCH_MODULEX_CONTENT, fetchModuleX);
  yield takeLatest(QUICK_VIEW_CONSTANT.GET_DATA_ON_NEW_FITS_CLICK, fetchDataonNewFitsClick);
}

export default QuickViewSaga;
